<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

       <div class="row">
         <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="PatientDetails">
           <img class="img-circle-56 margin-left-10px" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
         </div>
         <div class="col-md-2 line-height-17px padding-left-0px padding-right-0px" *ngIf="PatientDetails">
           <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
           <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
           <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
         </div>
         <!--<div class="col-md-3" *ngIf="PatientDetails">
           
         </div>-->
         <div class="col-md-7 line-height-17px">
           <!--<label class="margin-bottom-0px">{{ sectionData.Title }}</label>-->
           <label class="margin-bottom-0px font-weight-normal" *ngIf="TemplateName">{{TemplateName}}</label>
           <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="Date">{{Date|date:'dd-MM-yyyy'}}</label></div>
           <div class="row font-weight-700">
             <!--<div class="col-md-4">
               <label class="font-size-14 font-weight-normal margin-bottom-0px">Section Name</label>
             </div>:-->
             <div class="col-md-12  color-title padding-right-0px">
               <label *ngIf="TitleName" class="font-size-16px font-weight-bold margin-bottom-0px  margin-top-3px">{{TitleName}}</label>
              
             </div>
           </div>
           <!--<div class="row font-weight-700">
             <div class="col-md-2">
               <label class="font-size-14 font-weight-normal margin-bottom-0px"> Sign2 </label>
             </div>:
             <div class="col-md-8 font-size-14 font-weight-normal">
              
               <label *ngIf="Sign2" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign2}}</label>
             </div>
           </div>-->
         </div>
         <div class="col-md-2 ">
           <!--<button type="button" class="close float-right" data-dismiss="modal"
          (click)="activeModal.dismiss('Cross click')"
          aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>-->
           <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>
           <button (click)="onSubmit()" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
         </div>
       </div>
        <!--{{ sectionData.Title }}-->

       
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px  padding-bottom-5px">




            <div class="row">
              <div class="col-md-3  border-7px-form-right padding-left-5px padding-right-5px">
                <div class="row">
                  <div class="col-md-11 padding-right-0px padding-left-5px margin-top-5px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                </div>
                <div class="health-records-modal margin-top-5px">
                  <div class="row" *ngFor="let field of sectionData.Fields">
                    <!--<label *ngIf="field.isHeader && (field.ValueType == null || field.ValueType == 'List')">{{field.Title}}</label>-->
                    <a *ngIf="field.isHeader && (field.ValueType == null || field.ValueType == 'List')"
                       class="nav-link-hand margin-left-15px margin-top-5px color-Assign font-size-14 font-weight-bold">{{field.Title}}</a>
                    <a *ngIf="field.isSubHeader && (field.ValueType == null || field.ValueType == 'List')"
                       class="nav-link-hand margin-left-15px margin-top-5px color-new-data font-size-12px ">{{field.Title}}</a>
                  </div>
                </div>
              </div>
              <div class="col-md-9 health-records-modal">
                <div class="row margin-left-auto">
                  <div class="col-md-12 padding-l-0px" *ngFor="let section of  fo.AutoSections">
                    <!--<label class="red-bg">{{section.SectionType}} , Children Count:{{section.Fields.length}}</label>-->
                    <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">
                      <div *ngIf="field.isHeader && (field.ValueType == null || field.ValueType == 'List')">
                        <h4 class="font-size-18px margin-bottom-0px color-Assign"> {{field.Title}}</h4>
                       

                      </div>
                      <!--<label class="red-bg blue">{{field.Data.Title}} , Field Type:{{field.Data.ValueType}}</label>-->
                    <div [ngSwitch]="field.Data.ValueType">
                      <div class="row" *ngSwitchCase="'Bool'">
                        <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data">
                        </auto-gen-bool>
                      </div>
                      <div class="row" *ngSwitchCase="'List'">
                        <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data">
                        </auto-gen-list>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                        <auto-gen-text class="col-md-12" [field]="field.Data"></auto-gen-text>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                        <auto-gen-cvs class="col-md-12" [field]="field.Data"></auto-gen-cvs>
                      </div>
                      <div class="row margin-top-5px" *ngSwitchCase="'CsvList'">
                        <auto-gen-csvlist class="col-md-12" [field]="field.Data" [Data]="field"></auto-gen-csvlist>
                      </div>
                      <div class="row" *ngSwitchCase="'Date'">
                        <auto-gen-date class="col-md-12" [field]="field.Data"></auto-gen-date>
                      </div>
                      <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                        <!--<label>Grid: {{field.Title}}</label>-->
                        <auto-gen-grid class="col-md-12" [field]="field" [Date]="Date" [TemplateName]="TemplateName" [TitleName]="TitleName"></auto-gen-grid>
                      </div>
                      <div class="row" *ngSwitchDefault>
                        <!--<label class="red-bg">Other: {{field.Data.Title}} , Field Type:{{field.Data.ValueType}}</label>-->
                      </div>
                    </div>
                    </div>
                  </div>
                  </div>
                </div>
                
            </div>



           


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <!--<div class="modal-footer float-right col-md-12">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
          </div>-->
        </form>
      </div>
    </div>
  </div>
</div>
